import { useState } from "react";
import { playLines } from "@/mocks/home";

export default function PlayLines() {
  const [activeId, setActiveId] = useState(playLines[0].id);
  const active = playLines.find((line) => line.id === activeId) ?? playLines[0];

  return (
    <section id="playlines" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="mb-8 max-w-3xl">
          <span className="font-label text-xs tracking-widest text-primary-600">PLAYBACK</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            播放线路：按网络与画质选一条
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            同一部内容往往准备了不止一条在线播放线路。它们的差别不在内容本身，而在于清晰度、加载速度与适用设备。点击下面的标签即可切换查看。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[320px_1fr]">
          <div className="flex flex-col gap-2 rounded-lg border border-background-200 bg-background-100/70 p-3">
            {playLines.map((line) => {
              const isActive = line.id === activeId;
              return (
                <button
                  key={line.id}
                  type="button"
                  aria-pressed={isActive}
                  onClick={() => setActiveId(line.id)}
                  className={`flex items-center justify-between rounded-md px-4 py-3 text-left transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-50 text-foreground-800 hover:bg-background-200/70"
                  }`}
                >
                  <span className="font-label text-sm font-medium">{line.name}</span>
                  <span
                    className={`rounded-full px-2 py-0.5 text-[11px] font-label ${
                      isActive ? "bg-background-50/20 text-background-50" : "bg-accent-100 text-accent-800"
                    }`}
                  >
                    {line.badge}
                  </span>
                </button>
              );
            })}
            <p className="px-2 pt-1 text-xs leading-relaxed text-foreground-500">
              小提示：线路之间内容一致，切换只影响画质与加载体验。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100/70 p-6 md:p-8">
            <div className="flex flex-wrap items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-600">
                <i className="ri-play-circle-line"></i>
              </span>
              <div>
                <h3 className="font-heading text-xl font-semibold text-foreground-950">{active.name}</h3>
                <p className="text-xs font-label text-foreground-500">当前选中的播放线路</p>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
              <div className="rounded-md bg-background-50 p-4">
                <p className="font-label text-xs text-foreground-500">清晰度</p>
                <p className="mt-1 font-heading text-base font-semibold text-foreground-950">{active.quality}</p>
              </div>
              <div className="rounded-md bg-background-50 p-4">
                <p className="font-label text-xs text-foreground-500">加载速度</p>
                <p className="mt-1 font-heading text-base font-semibold text-foreground-950">{active.speed}</p>
              </div>
              <div className="rounded-md bg-background-50 p-4">
                <p className="font-label text-xs text-foreground-500">适用设备</p>
                <p className="mt-1 font-heading text-base font-semibold text-foreground-950">{active.devices}</p>
              </div>
            </div>

            <p className="mt-6 text-sm leading-relaxed text-foreground-700">{active.note}</p>

            <div className="mt-6 flex flex-wrap gap-2">
              {active.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-label text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}